/** User-facing product name for the standalone PDF workspace (pairs with Photo Studio). */
export const PDF_STUDIO_NAME = 'PDF Studio';
